import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { format } from 'date-fns';

const { FiMapPin, FiClock, FiTrendingUp, FiZap } = FiIcons;

const ActivityCard = ({ 
  activity, 
  isSelected, 
  onClick, 
  formatDistance, 
  formatTime, 
  formatPace 
}) => {
  const activityDate = new Date(activity.start_date);

  return (
    <motion.div
      onClick={onClick}
      className={`
        cursor-pointer p-4 rounded-xl border transition-all duration-300
        ${isSelected 
          ? 'bg-gradient-to-r from-orange-500/20 to-pink-500/20 border-orange-500/50 shadow-lg shadow-orange-500/20' 
          : 'bg-white/5 border-white/10 hover:bg-white/10 hover:border-white/20'
        }
      `}
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      layout
    >
      <div className="flex items-start justify-between mb-3">
        <div className="flex-1">
          <h3 className="font-semibold text-white text-lg mb-1">
            {activity.name}
          </h3>
          <p className="text-gray-400 text-sm">
            {format(activityDate, 'MMM dd, yyyy • HH:mm')}
          </p>
        </div>
        <div className={`
          px-3 py-1 rounded-full text-xs font-medium
          ${activity.type === 'Run' 
            ? 'bg-green-500/20 text-green-300 border border-green-500/30' 
            : 'bg-blue-500/20 text-blue-300 border border-blue-500/30'
          }
        `}>
          {activity.type}
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div className="flex items-center gap-2">
          <SafeIcon icon={FiMapPin} className="w-4 h-4 text-orange-400" />
          <div>
            <p className="text-white font-medium">{formatDistance(activity.distance)}</p>
            <p className="text-gray-400 text-xs">Distance</p>
          </div>
        </div>

        <div className="flex items-center gap-2">
          <SafeIcon icon={FiClock} className="w-4 h-4 text-blue-400" />
          <div>
            <p className="text-white font-medium">{formatTime(activity.moving_time)}</p>
            <p className="text-gray-400 text-xs">Time</p>
          </div>
        </div>

        <div className="flex items-center gap-2">
          <SafeIcon icon={FiZap} className="w-4 h-4 text-yellow-400" />
          <div>
            <p className="text-white font-medium">{formatPace(activity.average_speed)}</p>
            <p className="text-gray-400 text-xs">Avg Pace</p>
          </div>
        </div>

        <div className="flex items-center gap-2">
          <SafeIcon icon={FiTrendingUp} className="w-4 h-4 text-green-400" />
          <div>
            <p className="text-white font-medium">{activity.total_elevation_gain}m</p>
            <p className="text-gray-400 text-xs">Elevation</p>
          </div>
        </div>
      </div>

      {isSelected && (
        <motion.div
          className="mt-3 pt-3 border-t border-white/10"
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: 'auto' }}
          transition={{ duration: 0.3 }}
        >
          <p className="text-orange-400 text-sm font-medium">
            ✨ Click to view tempo visualization
          </p>
        </motion.div>
      )}
    </motion.div>
  );
};

export default ActivityCard;